import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { LastLocationProvider } from "react-router-last-location";
import { Routes } from "./app/router/Routes";
import { I18nProvider, LayoutSplashScreen } from "./_metronic";
import { Intercom } from 'app/main/Intercom';
import ThemeProvider from 'app/Wrappers/ThemeProvider';
import {ToastContainer} from "react-toastify";
import { IntercomProvider } from "react-use-intercom";
import config from "config";
import "assets/icon.css";

import "app/pages/home/shared.css";
import "app/assets/icon.css";
import 'react-toastify/dist/ReactToastify.css';
import "app/assets/main.scss";


export default function App({ store, persistor, basename }) {
  return (
    /* Provide Redux store */
    <Provider store={store} >
      {/* Intercom Provider - Initialize Intercom context */}
      <IntercomProvider appId={config.intercom.APP_ID}>
        {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
        <PersistGate persistor={persistor}>
          {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
          <React.Suspense fallback={<LayoutSplashScreen />}>
            {/* Override `basename` (e.g: `homepage` in `package.json`) */}
            <BrowserRouter basename={basename}>
              {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
              <LastLocationProvider>
                {/* Provide Metronic theme overrides. */}
                <ThemeProvider>
                  {/* Provide `react-intl` context synchronized with Redux state.  */}
                  <I18nProvider>
                    <Routes />
                    <Intercom />
                    <ToastContainer />
                    <div id="notification-root" />
                  </I18nProvider>
                </ThemeProvider>
              </LastLocationProvider>
            </BrowserRouter>
          </React.Suspense>
        </PersistGate>
      </IntercomProvider>
    </Provider>
  );
}
